<template>
    <el-card class="card">
        <template v-slot:header>
        <div class="clearfix">
            <span style="font-weight: bold;"><i class="el-icon-tickets" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>List of Gene-Enhancers</span>
            <el-button type="primary" icon="el-icon-download" size="small" @click="exportCsv" class="custom-button">Download</el-button>
        </div>
        </template>
        <div>
        <el-table :data="paginationData" style="width:100%;max-height: auto;color:black;" empty-text="No data available." fit>
            <el-table-column prop="Gene" label="Gene"></el-table-column>
            <el-table-column prop="TPM" label="TPM"></el-table-column>
            <el-table-column prop="Coreid" label="En_id"></el-table-column>
            <el-table-column prop="Chr" label="Chr"></el-table-column>
            <el-table-column prop="Corestart" label="Start"></el-table-column>
            <el-table-column prop="End" label="End"></el-table-column>
            <el-table-column prop="Species" label="Species"></el-table-column>
            <el-table-column prop="Tissue" label="Tissue"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                :current-page="currentPageRange"
                :page-size="pageSize"
                :total="tableData.length"
                :page-count="pageCount"
                @current-change="handleCurrentChange"
                :background="true"
                layout="prev, pager, next"
            ></el-pagination>
        </div>
        </div>
    </el-card>
</template>
    
<script>
export default {
    props: {
      species: {
        type: String,
        required: true
      },
      tissue: {
        type: [String, Array], // 现在它可以接受字符串或数组
        required: true
      },
      gene: {
        type: String,
        required: true
      },
      pageSize: {
        type: Number,
        default: 10
      }
    },
    data() {
        return {
            url: "http://183.175.59.4/devenhancer/",
            records: [], // 查询结果数据
            currentPage: 1,
        }
    },
    computed: {
        tableData() {
            return this.records;
        },
        pageCount() {
            return Math.ceil(this.tableData.length / this.pageSize);
        },
        paginationData() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.tableData.slice(start, end);
        },
        currentPageRange() {
            return Math.max(1, Math.min(this.currentPage, this.pageCount));
        }
    },
    mounted() {
      this.handleSearch();
    },
    methods: {
        handleSearch() {
            const params = {
                Species: this.species,
                Tissue: this.tissue,
                Gene: this.gene,
            };
            this.$axios.get(this.url + "Geneen" + "/", { params })
            .then(response => {
                this.records = response.data
            })
            .catch(error => {
                console.log(error)
                this.message.error('Failed to fetch data.')
            })
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        exportCsv() {
            const header = ['Gene', 'TPM', 'En_id', 'Chr', 'Start', 'End', 'Species', 'Tissue'];//如果换别的数据，注意换表头
            //如果换别的数据，注意换内容,对应prop
            const data = this.tableData.map(row => ({
                Gene: row.Gene,
                TPM: row.TPM,
                En_id: row.Coreid,
                Chr: row.Chr,
                Start: row.Corestart,
                End: row.End,
                Species: row.Species,
                Tissue: row.Tissue
            }));
            const csv = [
            header.join(','),
            ...data.map(row => Object.values(row).join(','))
            ].join('\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'list.csv');//输出文件的名字
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    },
    watch: {
        selectData(newVal, oldVal) {
            this.currentPage = 1;
        }
    }
}
</script>
    
<style scoped>
.card{
    margin-top: 10px;
}
.pagination {
    text-align: center;
    margin: 20px 0;
}
.custom-button {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
</style>


// WEBPACK FOOTER //
// src/components/home/Genelist.vue